interface DataItem {
	[key: string]: any; // To allow any key-value pairs for each data item
}

export const groupBy = <T extends DataItem, K extends keyof T>(arr: T[], key: K): { key: T[K]; items: T[] }[] => {
	if (!arr) return [];

	const groupedData = arr.reduce(
		(acc, item) => {
			const keyValue = item[key]; // Use the passed key to group
			if (!acc[keyValue]) {
				acc[keyValue] = [];
			}
			acc[keyValue].push(item);
			return acc;
		},
		{} as Record<T[K], T[]>,
	);

	// Convert the grouped object into an array of group objects
	return Object.keys(groupedData).map((key) => ({
		key: key as T[K], // The key of each group (explicitly cast to T[K])
		items: groupedData[key as T[K]],
	}));
};

// /**
//  * Returns a formatted period text based on the given `period` string.
//  * It checks if the input contains "week", "month", or "year" and returns
//  * "per week", "per month", or "per year" respectively. If no match is found,
//  * it returns an empty string.
//  *
//  * @param period - The input string representing a time period.
//  * @returns A formatted string indicating the period duration.
//  */
// export const getPeriodText = (period: string) => {
// 	if (period.includes('Monthly')) return '';
// 	if (period.includes('Yearly')) return '';
// 	return '';
// };
export const convertToGb = (value: string): number => {
	if (!value) return 0;
	const trimmedValue = value.trim().toUpperCase();
	const match = trimmedValue.match(/^([\d.]+)\s*(GB|TB)$/);
	if (!match) return 0;
	const amount = parseFloat(match[1]);
	const unit = match[2];
	if (isNaN(amount)) return 0;
	if (unit === 'TB') {
		return amount * 1024;
	}
	return amount;
};
export const getMonthlyPrice = (yearlyPrice: number, plandata: string) => {
	if (typeof yearlyPrice !== 'number') return 'N/A';
	const gbData = convertToGb(plandata);
	const monthly = yearlyPrice / gbData;
	return Number(monthly.toFixed(2)); // standard rounding logic
};
